import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewQuestionnaireComponent } from './preview-questionnaire.component';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PreviewQuestionnaireBlocksComponent } from './preview-questionnaire-blocks/preview-questionnaire-blocks.component';
import { ButtonModule, TagsModule } from '@xref/xref-lib';



@NgModule({
  declarations: [PreviewQuestionnaireComponent, PreviewQuestionnaireBlocksComponent],
  imports: [
    CommonModule,
    TooltipEllipsifyModule,
    TooltipModule.forRoot(),
    TagsModule,
    ButtonModule
  ],
  exports: [PreviewQuestionnaireComponent],
})
export class PreviewQuestionnaireModule { }
